"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const util_1 = require("@turajs/util");
const convertContractData_1 = require("./internal/convertContractData");
exports.generateMethodCall = (args) => {
    const MaxArgs = 3;
    const argArray = args.methodArgs ? [args.methodHash, ...args.methodArgs] : [args.methodHash];
    if (argArray.length > MaxArgs + 1) {
        throw new Error(`At maximum ${MaxArgs} are supported`);
    }
    return argArray
        .map(convertContractData_1.convertContractData)
        .map(long => util_1.convertDecStringToHexString(long, 16))
        .map(util_1.convertHexEndianess)
        .join('');
};
//# sourceMappingURL=generateMethodCall.js.map